// app页面相关逻辑

/**
 * 跳转逻辑
 * @param url 链接
 */
export function jump(url) {
  return new Promise((resolve) => {
    _tc_bridge_web.open_newurl({
      param: {
        openParams: 'newWindow,needSlide',
        jumpUrl: url
      },
      callback(data){
        resolve(data)
      }
    })
  })
}
